export const contactPoints = {
  phone: "+919653211699",
  email: "bcc@bombaycodingcompany.com",
  instagram: "https://www.instagram.com/bombaycodingco?igsh=ZXJzdXJxcWl3cnho",
  linkedin: "https://www.linkedin.com/in/bombay-coding-company-3bb619312",
  github: "https://github.com/BCC-Prod",
};
